<footer class="site-footer">
  <div class="container">
    <div class="row footer-cols">

      <!-- Localisation -->
      <div class="col-lg-4 footer-col mb-5 mb-lg-0">
        <h5 class="footer-title">{{'LOCALIZATION' | translate}}</h5>
        <div class="footer-accent"></div>
        <p class="pre-wrap footer-text">
          {{'NOMBAKELE' | translate}}<br>
          {{'LOCALIZATION_DESCRIPTION' | translate}}<br>
          APIP : 004-15503GUI du 04/09/2008
        </p>
        <div class="map-wrapper">
          <app-map-template [mapConfig]="mapConfig">
            <div class="block-infos-msg">-</div>
          </app-map-template>
        </div>
      </div>

      <!-- Réseaux sociaux -->
      <div class="col-lg-4 footer-col mb-5 mb-lg-0 text-center">
        <h5 class="footer-title">{{'ON_INTERNET' | translate}}</h5>
        <div class="footer-accent mx-auto"></div>
        <div class="social-icons">
          <a class="social-icon" href="https://www.facebook.com/constance.bakala"
             target="_blank" rel="noopener" aria-label="Facebook">
            <i class="fab fa-facebook-f"></i>
          </a>
          <a class="social-icon" href="https://www.twitter.com/BakalaConstance"
             target="_blank" rel="noopener" aria-label="Twitter / X">
            <i class="fab fa-twitter"></i>
          </a>
        </div>
      </div>

      <!-- À propos -->
      <div class="col-lg-4 footer-col">
        <h5 class="footer-title">{{'ABOUT_ME' | translate}}</h5>
        <div class="footer-accent"></div>
        <p class="pre-wrap footer-text">{{'ABOUT_CONSTANCE' | translate}}</p>
      </div>

    </div>
  </div>
</footer>

<section class="copyright-bar">
  <div class="container text-center">
    <small class="pre-wrap">
      Copyright &copy; Délice-Éternel 2020
      <span [innerHTML]="'v' + version + (isProd ? '' : '&nbsp;[' + envName + ']')"></span>
    </small>
  </div>
</section>

<!-- Scroll to top (mobile uniquement) -->
<div class="scroll-to-top d-lg-none position-fixed">
  <a class="scroll-top-btn js-scroll-trigger" href="#page-top">
    <i class="fa fa-chevron-up"></i>
  </a>
</div>
